export const getMarkers = input => input.value || null;

export const getPosition = e => ({
  lng: e.latLng.lng(),
  lat: e.latLng.lat(),
});


const degreesToRadians = (degrees) =>{
  return degrees * Math.PI / 180;
};

const radiansToDegrees = (radians) => {
  return radians * (180 / Math.PI);
}

export const getMidPoint = (lat1, lng1, lat2, lng2) => {

  //-- Longitude difference
  var dLng = degreesToRadians(lng2 - lng1);

  //-- Convert to radians
  lat1 = degreesToRadians(lat1);
  lat2 = degreesToRadians(lat2);
  lng1 = degreesToRadians(lng1);

  var bX = Math.cos(lat2) * Math.cos(dLng);
  var bY = Math.cos(lat2) * Math.sin(dLng);
  var lat3 = Math.atan2(Math.sin(lat1) + Math.sin(lat2), Math.sqrt((Math.cos(lat1) + bX) * (Math.cos(lat1) + bX) + bY * bY));
  var lng3 = lng1 + Math.atan2(bY, Math.cos(lat1) + bX);

  //-- Return result
  return {lat: radiansToDegrees(lat3), lng: radiansToDegrees(lng3)};
};